import { useQuery } from "@tanstack/react-query";
import { InsurancePayerControllerApi } from "../services";
import { getConfigObject, useBaseContent } from "../utils/utils";

interface Props {
  searchKey?: string;
  xTENANTID?: string | undefined;
  enabled?: boolean;
}

type OptionData = {
  payerId: string;
  payerName: string;
};

/**
 *
 * @author Shrinivas Mandhare
 */
export const useInsurancePayerList = ({
  searchKey,
  xTENANTID,
  enabled,
}: Props): useBaseContent<OptionData> =>
  useQuery({
    queryKey: ["insurance-payer-list", xTENANTID, searchKey],
    refetchOnWindowFocus: false,
    enabled: enabled ?? true,
    queryFn: async () => {
      const response = await new InsurancePayerControllerApi(
        getConfigObject()
      ).getAllInsurancePayer(
        undefined, // page
        10, // size
        undefined, // sortBy
        undefined, // sortDirection
        searchKey, //searchString
        xTENANTID // xTENANTID
      );
      return response?.data;
    },
  });
